import React from 'react';

export const AboutPage = () => (
    <div className="space-y-6">
        <h2 className="text-4xl font-extrabold text-center text-indigo-700 dark:text-indigo-300 mb-4 transition-colors duration-300">About Us</h2>

        {/* Intro callout */}
        <div className="rounded-lg border border-indigo-100 dark:border-indigo-900/40 bg-indigo-50 dark:bg-indigo-900/20 p-5">
            <p className="text-base sm:text-lg leading-relaxed text-indigo-900 dark:text-indigo-100">
                <span className="font-semibold">All skill levels are welcome.</span> Whether you're new to darts or a seasoned player, our league is friendly, inclusive, and focused on good games with good people.
            </p>
        </div>

        {/* Core message split into digestible sections */}
        <div className="grid gap-5 md:grid-cols-2">
            <div className="rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-5">
                <h3 className="text-xl font-semibold text-indigo-700 dark:text-indigo-300 mb-2">Community & Sportsmanship</h3>
                <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                    We value camaraderie and friendly competition. Players of all experience levels can learn, improve, and enjoy the game in a welcoming environment.
                </p>
            </div>
            <div className="rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-5">
                <h3 className="text-xl font-semibold text-indigo-700 dark:text-indigo-300 mb-2">Learn & Grow</h3>
                <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                    Seasoned members openly share tips and strategy. Newer players bring fresh energy. Together we foster mentorship, curiosity, and better darts.
                </p>
            </div>
            <div className="rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-5">
                <h3 className="text-xl font-semibold text-indigo-700 dark:text-indigo-300 mb-2">Matches & Events</h3>
                <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                    Regular league nights, tournaments, and practice sessions run throughout the year—plenty of chances to throw, improve, and have fun.
                </p>
            </div>
            <div className="rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-5">
                <h3 className="text-xl font-semibold text-indigo-700 dark:text-indigo-300 mb-2">Join In</h3>
                <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
                    Whether you seek competitive challenge or a relaxed social night out, you’ll find a welcoming table and great company here.
                </p>
            </div>
        </div>

        {/* Vision & Values with subtle accents */}
        <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-indigo-50 dark:bg-gray-900 p-6 rounded-lg border border-indigo-100 dark:border-gray-800">
                <h3 className="text-2xl font-semibold text-indigo-700 dark:text-indigo-300 mb-3">Our Vision</h3>
                <p className="text-gray-700 dark:text-gray-200">To be the leading community for darts enthusiasts—recognized for integrity, inclusion, and joyful competition.</p>
            </div>
            <div className="bg-indigo-50 dark:bg-gray-900 p-6 rounded-lg border border-indigo-100 dark:border-gray-800">
                <h3 className="text-2xl font-semibold text-indigo-700 dark:text-indigo-300 mb-3">Our Values</h3>
                <ul className="space-y-1 text-gray-700 dark:text-gray-200">
                    <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-indigo-400"></span>Community</li>
                    <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-indigo-400"></span>Fair Play</li>
                    <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-indigo-400"></span>Excellence</li>
                    <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-indigo-400"></span>Inclusivity</li>
                </ul>
            </div>
        </div>
    </div>
);